<div class="flex flex-col h-screen bg-white">
  <vx-uidcheck-header class="flex-none"></vx-uidcheck-header>

  <main class="flex flex-col flex-1 min-h-0 container mx-auto py-4">
    <router-outlet></router-outlet>
  </main>
</div>
